/* global localStorage */
import { readRecentSearches } from './relatedListings/recentItemsModules'

// localStorage recent searches carry no timestamps, so we record when each was last searched.

function lastSearchedStorageKey (locale) {
  return locale ? `RECENT_SEARCH_LAST_SEARCHED_${locale}` : 'RECENT_SEARCH_LAST_SEARCHED'
}

export function readLastSearchedTimes (locale) {
  try {
    return JSON.parse(localStorage.getItem(lastSearchedStorageKey(locale))) || {}
  } catch {
    return {}
  }
}

export function recordSearch () {
  const query = (new URLSearchParams(window.location.search).get('q') || '').trim()
  if (!query) return

  const { locale, searches } = readRecentSearches()
  const liveTerms = new Set(searches.map(search => (search.id || '').toLowerCase()))
  liveTerms.add(query.toLowerCase())

  const now = Date.now()
  const recencyMs = 30 * 24 * 60 * 60 * 1000
  const lastSearchedTimes = readLastSearchedTimes(locale)
  lastSearchedTimes[query.toLowerCase()] = now

  const pruned = {}
  Object.keys(lastSearchedTimes).forEach(term => {
    if (liveTerms.has(term) && (now - lastSearchedTimes[term]) <= recencyMs) pruned[term] = lastSearchedTimes[term]
  })

  localStorage.setItem(lastSearchedStorageKey(locale), JSON.stringify(pruned))
}
